import { Text } from '@pairy/pds-react';
import { FormEvent, useEffect, useRef, useState } from 'react';

import * as Styled from './index.styles';

interface Props {
  currentPage: number;
  totalPages: number;
  goToPage: (page: number) => void;
  translateKoToEn: (item: string) => string;
}

/** "n / N" 페이지 표시. 클릭하면 입력 모드로 전환해 페이지 점프가 가능하다. */
const PageIndicator = ({
  currentPage,
  totalPages,
  goToPage,
  translateKoToEn,
}: Props) => {
  const [isEditable, setIsEditable] = useState(false);
  const [inputValue, setInputValue] = useState(String(currentPage));
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!isEditable) {
      setInputValue(String(currentPage));
    }
  }, [currentPage, isEditable]);

  useEffect(() => {
    if (isEditable) {
      inputRef.current?.focus();
      inputRef.current?.select();
    }
  }, [isEditable]);

  const submitPage = () => {
    const page = Number(inputValue);

    if (!Number.isNaN(page) && page >= 1 && page <= totalPages) {
      goToPage(page);
    }

    setIsEditable(false);
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    submitPage();
  };

  return (
    <Styled.Wrapper alignItems="center" gap={4}>
      {isEditable ? (
        <form onSubmit={handleSubmit}>
          <Styled.PageInput
            ref={inputRef}
            type="number"
            min={1}
            max={totalPages}
            value={inputValue}
            aria-label={translateKoToEn('go-to-page')}
            onChange={(e) => setInputValue(e.target.value)}
            onBlur={submitPage}
          />
        </form>
      ) : (
        <Styled.CurrentPageButton
          type="button"
          aria-label={translateKoToEn('go-to-page')}
          title={translateKoToEn('go-to-page')}
          onClick={(e) => {
            e.stopPropagation();
            setIsEditable(true);
          }}
        >
          <Text variant="md-medium" color="black">
            {currentPage}
          </Text>
        </Styled.CurrentPageButton>
      )}
      <Text variant="md-medium" color="black">
        / {totalPages}
      </Text>
    </Styled.Wrapper>
  );
};

export default PageIndicator;
